import { createFileRoute } from '@tanstack/react-router';
import { NestedRouteErrorBoundary } from '~/components/errors/NestedRouteErrorBoundary';
import { Projects } from '~/features/projects/Projects';

export const Route = createFileRoute('/_auth/_appLayout/')({
  component: Projects,
  errorComponent: NestedRouteErrorBoundary,
});
